import * as React from "react";
import { SVGProps } from "react";
const PatientsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.5}
    height={17.553}
    {...props}
  >
    <g
      fill={props.fill ?? "none"}
      stroke={props.stroke ?? "#172b4d"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      data-name="Component 6456"
    >
      <path
        d="M2.434 4.171A3.368 3.368 0 1 0 5.802.803a3.368 3.368 0 0 0-3.368 3.368"
        data-name="Path 5834"
      />
      <path
        d="M.75 15.961v-1.685a3.368 3.368 0 0 1 3.368-3.368h3.369a3.358 3.358 0 0 1 2.131.759"
        data-name="Path 5835"
      />
      <path d="M11.697.912a3.368 3.368 0 0 1 0 6.526" data-name="Path 5836" />
      <path d="M11.697 14.277h5.053" data-name="Path 5837" />
      <path d="M14.224 11.75v5.053" data-name="Path 5838" />
    </g>
  </svg>
);
export default PatientsIcon;
